import FormulaireBmw from "./FormulaireBmw";

export const Bmw=()=> {
  return (
    <>
      <section className="sectionBmw">
        <FormulaireBmw />
      </section>
    </>
  );
}


